var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#002240",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8471 13.4975L8.94709 1.5475C8.52709 0.8175 7.46709 0.8175 7.03709 1.5475L0.147088 13.4975C-0.272912 14.2275 0.257088 15.1475 1.09709 15.1475H14.8971C15.7371 15.1475 16.2671 14.2275 15.8471 13.4975ZM8.69709 13.5375C8.30709 13.9275 7.66709 13.9175 7.28709 13.5275C6.89709 13.1275 6.89709 12.4975 7.29709 12.1075C7.68709 11.7175 8.32709 11.7275 8.70709 12.1175C9.08709 12.5075 9.09709 13.1475 8.69709 13.5375ZM9.07709 9.8275C9.03709 10.3875 8.56709 10.8275 7.99709 10.8275C7.42709 10.8275 6.96709 10.3975 6.91709 9.8275L6.62709 5.9775C6.58709 5.3575 7.07709 4.8175 7.70709 4.8175H8.28709C8.91709 4.8175 9.40709 5.3475 9.36709 5.9775L9.07709 9.8275Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.d5fef20d3597c2988f27081ab25a6062.svg";
export { ForwardRef as ReactComponent };